/* global gettext */
import { ChartBuilder } from './chart-builder';
import 'echarts/build/echarts-all.js';
import { hoursToTime, ticksFormat, ticksToHours } from '../common/datetime';

// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/line';

/*@ngInject*/
class ChartController {
  constructor($scope, $element, RouterService, LayoutService, rx) {
    this.$scope = $scope;
    this.$element = $element;
    this.router = RouterService;
    this.LayoutService = LayoutService;
    this.container = null;
    this.chart = null;
    this.chartType = 'bar';
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.aggregate = null;
    this.filter = null;

    let subscriptions = [
      rx.Observable.merge(
        $scope.$eventToObservable('resize'),
        $scope.$eventToObservable('splitterChanged'),
      )/*.debounce(100)*/
        .subscribe(() => {
          this.resize();
        }),
      rx.Observable.merge(
        rx.Observable.merge(
          //$scope.$toObservable('$ctrl.filter'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(this.renderDebounce),
        $scope.$eventToObservable('beforePrint'),
        $scope.$eventToObservable('afterPrint'),
        $scope.$eventToObservable('init'),
      )
        .subscribe(() => {
          this.render();
        }),
    ];
    $scope.$on('$destroy', () => {
      subscriptions.forEach((subscription) => {
        subscription.dispose();
      });
    });
  }

  resize() {
    // console.log('chart resize width %s height %s print %s', this.$element.width(), this.$element.height(), this.LayoutService.isPrint);
    // console.log('chart parent width %s height %s', this.$element.parent().width(), this.$element.parent().height());

    if (this.chart && this.$element.height() > this.minHeight &&
      this.$element.width() > this.minWidth) {
      this.chart.resize();
    }
  }

  render() {
    if (!this.aggregate || !this.filter) {
      return;
    }
    // console.log('chart render width %s height %s print %s', this.$element.width(), this.$element.height(), this.LayoutService.isPrint);
    // console.log('chart parent width %s height %s', this.$element.parent().width(), this.$element.parent().height());

    if (this.$element.height() <= this.minHeight ||
      this.$element.width() <= this.minWidth) {
      return;
    }

    const isPrint = this.LayoutService.isPrint;
    let builder = new ChartBuilder(
      this.aggregate,
      this.filter,
      this.chartType,
      this.model,
    );
    builder.build();

    let axisLabelFormatter = this.filter.measure === 'activity_time_sum' ?
      value => hoursToTime(value) :
      value => value;

    this.container = this.$element[0];
    this.chart = echarts.init(this.container);
    this.chart.setOption({
      tooltip            : {
        trigger  : 'item',
        formatter: this.filter.measure === 'activity_time_sum' ?
          (params) => {
            return params.name + '<br/>'
              + ticksFormat(params.value * ticksToHours);
          } : null,
      },
      toolbox            : {
        show   : !isPrint,
        feature: {
          magicType  : {
            show : true,
            type : ['line', 'bar'],
            title: {
              line: gettext('Линейный График'),
              bar : gettext('Гистограмма'),
            },
          },
          // restore: {show: true},
          saveAsImage: {
            show : true,
            title: gettext('Сохранить'),
            lang : [gettext('Нажмите кнопку [Сохранить]')],
          },
        },
      },
      noDataLoadingOption: {
        text  : gettext(
          'Нет данных.\nВыберите пользователей, либо измените параметры фильтра.'),
        effect: 'bubble',
      },
      // calculable : true,
      dataZoom           : {
        show    : !isPrint,
        realtime: true,
        start   : 0,
        end     : 100,
      },
      legend             : {
        data: builder.legendData,
      },
      xAxis              : [
        {
          type: 'category',
          data: builder.xData,
        },
      ],
      yAxis              : [
        {
          type     : 'value',
          splitArea: {show: true},
          axisLabel: {
            formatter: axisLabelFormatter,
          },
        },
      ],
      series             : builder.yData,
      animation          : !isPrint,
      addDataAnimation   : !isPrint,
    });
    this.chart.on('magicTypeChanged', (e) => {
      let magicType = e.magicType;
      if (magicType.bar) {
        this.chartType = 'bar';
      }
      if (magicType.line) {
        this.chartType = 'line';
      }
    });
    this.chart.on('click', (e) => {
      if (!this.filter.drilldown.length) {
        return;
      }
      if (this.filter.drilldown.length > 0) {
        let filterValue = builder.filterValues[e.dataIndex];
        this.router.drilldownFilter(filterValue);
      }
      if (this.filter.drilldown.length > 1) {
        let filterValue = builder.filterYValues[e.seriesIndex];
        this.router.drilldownFilter(filterValue);
      }
      this.router.mode = 'explore';
      this.$scope.$root.$digest();
    });
    this.chart.resize();
  }
}

export const ChartComponent = {
  template: require('./chart.component.html'),
  bindings: {
    model    : '<',
    aggregate: '<',
    filter   : '<',
  },

  controller: ChartController,
};



// WEBPACK FOOTER //
// ./src/stat/chart.component.js